import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { Svg, Path } from 'react-native-svg';

interface BottomSheetHeaderProps {
  title: string;
  onClose: () => void;
}

export default function BottomSheetHeader({ title, onClose }: BottomSheetHeaderProps) {
  // Removed debug log
  
  return (
    <View style={styles.headerGroup}>
      <View style={styles.header}>
        {/* Left spacer */}
        <View style={styles.leftSpacer} />
        
        {/* Center title */}
        <View style={styles.titleContainer}>
          <Text style={styles.title}>{title}</Text>
        </View>
        
        {/* Right close button */}
        <TouchableOpacity onPress={onClose} style={styles.closeButton} activeOpacity={0.7}>
          <View style={styles.closeIcon}>
            <Svg width="18" height="18" viewBox="0 0 18 18" fill="none">
              <Path d="M4.5918 13.2426L13.0771 4.75733" stroke="#151515" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <Path d="M4.5918 4.75739L13.0771 13.2427" stroke="#151515" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </Svg>
          </View>
        </TouchableOpacity>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  headerGroup: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
    zIndex: 1000, // Ensure header is above other content
  },
  header: {
    paddingVertical: 16,
    paddingHorizontal: 24,
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    height: 56,
    flexDirection: 'row',
    zIndex: 1001, // Higher than parent
  },
  leftSpacer: {
    width: 24, // Same width as close button for centering
  },
  titleContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    color: '#151515',
    textAlign: 'center',
    fontFamily: 'Inter_700Bold',
    fontSize: 16, // Increased for better visibility
    lineHeight: 20, // Better line height
    zIndex: 1004, // Ensure text is on top
    backgroundColor: 'transparent', // Explicit background
  },
  closeButton: {
    justifyContent: 'center',
    alignItems: 'center',
    width: 24,
    height: 24,
    padding: 0, // Removed fractional padding
    zIndex: 1003, // Ensure close button is clickable
    backgroundColor: 'transparent',
  },
  closeIcon: {
    width: 18,
    height: 18,
    justifyContent: 'center',
    alignItems: 'center',
  },
});